// extracted by mini-css-extract-plugin
export default {"main":"et_main__9Lle7","h2":"et_h2__fh8da","h3":"et_h3__Yf2It","description":"et_description__SRvgA","full_img":"et_full_img__DYdVq","ul":"et_ul__FETHQ"};